<template>
  <div class="modal-card" style="width: auto; height:auto">
    <header class="modal-card-head flex justify-between">
      <p class="modal-card-title">
        Notifications for {{ name }}
      </p>
      <div>
        <filter-dropdown v-model="filter" class="text-base" />
        <d-btn class="" @click="launchCreateNotificationModal()">
          Send Notification
        </d-btn>
      </div>
    </header>
    <section class="modal-card-body">
      <d-table :data="notifications" :loading="loadingNotifications" paginated backend-pagination :total="total" backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" striped detail-key="id" default-sort-direction="desc" :per-page="pagination.pageSize" @page-change="page => pagination.page = page" @sort="onSort">
        <template slot-scope="props">
          <d-table-column field="createdAt" :row="props.row" label="Date" sortable>
            <span>{{ props.row.createdAt | formatShortDateTime }}</span>
          </d-table-column>
          <d-table-column field="fromName" :row="props.row" label="From" sortable>
            <span>{{ props.row.fromName }}</span>
          </d-table-column>
          <d-table-column field="subject" :row="props.row" label="Subject" sortable>
            <span>{{ props.row.subject }}</span>
          </d-table-column>
          <d-table-column v-if="type =='group'" field="role" :row="props.row" label="Filter" sortable>
            <span v-if="props.row.role">{{ props.row.role }}s</span>
            <span v-else>N/A</span>
          </d-table-column>
          <d-table-column field="view" :row="props.row" label="View" sortable>
            <a href="javascript:void(0)" @click="launchReadNotificationModal(props.row)">View</a>
          </d-table-column>
        </template>
      </d-table>
    </section>
    <footer class="modal-card-foot justify-end">
      <d-btn @click="$parent.close()">
        Close
      </d-btn>
    </footer>
  </div>
</template>

<script>
  import axios from 'axios';
  import CreateNotificationModal from '@resources/scripts/patterns/CreateNotificationModal.vue';
  import NotificationContentModal from '@resources/scripts/patterns/NotificationContentModal.vue';

  export default {
    parent: true,

    props: {
      type: {
        type: String,
        required: true,
      },
      entityId: {
        type: [String, Number],
        default: null,
        required: true,
      },
      name: {
        type: String,
        default: '',
        required: true,
      },
    },

    data: () => ({
      notifications: [],
      loadingNotifications: false,
      total: 0,
      filter: '',
      pagination: {
        page: 1,
        pageSize: 50,
        sortField: 'createdAt',
        sortOrder: 'desc',
      },
    }),

    watch: {
      pagination: {
        handler() {
          this.getNotificationsPaged();
        },
        deep: true,
      },
      filter() {
        this.getNotificationsPaged();
      },
    },

    mounted() {
      this.getNotificationsPaged();
    },

    methods: {
      async getNotificationsPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingNotifications = true;

        if (this.type === 'group') {
          const { data } = await axios.get(`/api/notifications/group/${this.entityId}/paged?${params}`);
          this.notifications = data.resultItems;
          this.total = data.totalRecords;
        } else {
          const { data } = await axios.get(`/api/notifications/user/${this.entityId}/paged?${params}`);
          this.notifications = data.resultItems;
          this.total = data.totalRecords;
        }
        this.loadingNotifications = false;
      },

      launchCreateNotificationModal() {
        this.$modal.open({
          parent: this,
          component: CreateNotificationModal,
          hasModalCard: true,
          events: {
            getNotificationsPaged: () => this.getNotificationsPaged(),
          },
          props: {
            entityId: this.entityId,
            type: this.type,
          },
        });
      },

      async launchReadNotificationModal(notification) {
        this.$modal.open({
          parent: this,
          component: NotificationContentModal,
          hasModalCard: true,
          width: 800,
          props: {
            notification,
          },
        });
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },
    },
  };
</script>
